import { VpIcon } from '@vtmn-play/react'
import type { ActionChoiceDto } from '@/infra/api/generated/model'

type ActionChoiceButtonProps = {
  actionChoice: ActionChoiceDto
  selected: boolean
  onActionClick: (action: ActionChoiceDto) => void
}

export const ActionChoiceButton = ({
  actionChoice,
  selected,
  onActionClick,
}: ActionChoiceButtonProps) => (
  <button
    data-testid="action-choice-button"
    className={`flex gap-3 justify-between items-center text-start transition-colors ${
      selected ? 'text-black font-bold' : 'text-gray-500 font-normal'
    }`}
    onClick={() => onActionClick(actionChoice)}
  >
    <span
      className={`flex items-center justify-center p-1 rounded-full border transition-colors ${
        selected
          ? 'bg-primary-blue border-primary-blue text-white'
          : 'bg-transparent border-gray-400 text-gray-400'
      }`}
    >
      <VpIcon size={24} name={selected ? 'check' : 'add'} />
    </span>
    <span>{actionChoice.label}</span>
  </button>
)
